import React, {useEffect, useState} from 'react';
import {EmptyContainer} from '../styles';
import Img6 from '../../../assets/images/6.png';
import {config} from '../../../utils/config/config';
import {VelocityTabs, VelocityWhiteHeader, VelocityWhiteTable} from './styles';
import {
  EmptyCard,
  EmptyImage,
  FluidContainer,
  LargeButton,
  PowerDropdown,
  SimpleTabs,
  VelocityTable,
  WhiteContainer,
} from '../../../components';
import { useLocation, useNavigate } from 'react-router-dom';

const DefaultTabs = [
  {
    title: 'AVERAGE',
    url: 'average',
    icon: '',
    action: () => {},
  },
  {
    title: 'PREVIOUS',
    url: 'previous',
    icon: '',
    action: () => {},
  },
  {
    title: 'BASELINE',
    url: 'baseline',
    icon: '',
    action: () => {},
  },
];

const DefaultEvents = [
  {title: 'All', value: 'All'},
  {title: 'Game', value: 'Game'},
  {title: 'Training', value: 'Training'},
  {title: 'Play', value: 'Play'},
];

const DefaultSituation = [
  {title: 'All', value: 'All'},
  {title: 'Game', value: 'Game'},
  {title: 'Training', value: 'Training'},
  {title: 'Play', value: 'Play'},
];

const DefaultBall = [
  {title: 'All', value: 'All'},
  {title: 'Game', value: 'Game'},
  {title: 'Training', value: 'Training'},
  {title: 'Play', value: 'Play'},
];

const DefaultPitch = [
  {title: 'All', value: 'All'},
  {title: 'Game', value: 'Game'},
  {title: 'Training', value: 'Training'},
  {title: 'Play', value: 'Play'},
];

export default () => {
  const [situation, useSituation] = useState<any>(DefaultSituation[0]);
  const [events, useEvents] = useState<any>(DefaultEvents[0]);
  const [pitch, usePitch] = useState<any>(DefaultPitch[0]);
  const [ball, useBall] = useState<any>(DefaultBall[0]);
  const navigate = useNavigate();

  useEffect(() => {
    if (!window.location.href.includes('/players/exams/')) {
      navigate('/players/velocityTest/previous');
    }
    // eslint-disable-next-line
  }, [history]);

  function HandleEvents(selectedOption: object | any) {
    useEvents(selectedOption);
  }

  function HandleSituations(selectedOption: object | any) {
    useSituation(selectedOption);
  }

  function HandleBall(selectedOption: object | any) {
    useBall(selectedOption);
  }

  function HandlePitch(selectedOption: object | any) {
    usePitch(selectedOption);
  }

  return config.blocked ? (
    <EmptyContainer>
      <EmptyCard />
      <EmptyImage src={Img6} />
    </EmptyContainer>
  ) : (
    <FluidContainer>
      <VelocityTabs>
        <SimpleTabs dataCy="velocity-tab" dataArray={DefaultTabs} url="/players/velocityTest" />
      </VelocityTabs>
      <WhiteContainer>
        <div style={{display: 'flex', justifyContent: 'flex-end'}}>
          <VelocityWhiteHeader data-cy="velocity-white-header">
            <PowerDropdown
              search={false}
              mWidth="170px"
              firstActve={true}
              permaTitle="Event:"
              onClick={HandleEvents}
              dataArray={DefaultEvents}
              primaryTitle={events.title}
            />
            <PowerDropdown
              search={false}
              mWidth="170px"
              firstActve={true}
              permaTitle="Situation:"
              onClick={HandleSituations}
              dataArray={DefaultSituation}
              primaryTitle={situation.title}
            />
            <PowerDropdown
              search={false}
              mWidth="170px"
              firstActve={true}
              permaTitle="Ball Type:"
              onClick={HandleBall}
              dataArray={DefaultBall}
              primaryTitle={ball.title}
            />
            <PowerDropdown
              search={false}
              mWidth="170px"
              firstActve={true}
              permaTitle="Pitch Type:"
              onClick={HandlePitch}
              dataArray={DefaultPitch}
              primaryTitle={pitch.title}
            />
            <LargeButton
              title="d"
              lColor="var(--PrimaryGreen)"
              rColor="var(--SecondaryGreen)"
              lMargin="0px 7px"
              rMargin="0px 10px"
              icon="excel"
              rIcon="download"
              callback={() => {}}
            />
          </VelocityWhiteHeader>
        </div>
        <VelocityWhiteTable data-cy="velocity-table-container">
          <VelocityTable />
        </VelocityWhiteTable>
      </WhiteContainer>
    </FluidContainer>
  );
};
